import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { integrations } from "../mock";

export default function Integrations() {
  return (
    <section className="border-t border-slate-200/80 bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
            Integrations
          </p>
          <h2 className="mx-auto mt-3 max-w-3xl text-4xl font-medium tracking-tight text-[#1e1b4b] sm:text-5xl">
            One platform.{" "}
            <span className="text-slate-400">Every channel.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-slate-600">
            Push enriched audiences into the tools your team already uses — ads,
            CRM, email, warehouse, direct mail. 200+ native integrations, plus
            full API and webhook access.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-6">
          {integrations.map((i) => (
            <div
              key={i.name}
              className="group flex flex-col items-center gap-3 rounded-xl border border-slate-200 bg-white px-3 py-5 transition-all hover:-translate-y-0.5 hover:border-[#1e1b4b]/20 hover:shadow-md"
            >
              <div
                className="flex h-10 w-10 items-center justify-center rounded-lg text-sm font-bold text-white shadow-sm"
                style={{ backgroundColor: i.color }}
              >
                <span style={{ color: i.color === "#FFE01B" ? "#1e1b4b" : "#fff" }}>
                  {i.initials}
                </span>
              </div>
              <span className="text-center text-xs text-slate-600">{i.name}</span>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-center gap-3 text-sm sm:flex-row">
          <span className="text-slate-600">200+ platforms supported</span>
          <span className="hidden h-1 w-1 rounded-full bg-slate-300 sm:block" />
          <Link
            to="/integrations"
            className="group inline-flex items-center gap-1 font-medium text-[#1e1b4b] hover:text-[#d4af37]"
          >
            View all integrations
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
